import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from "@angular/core";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { DialogModule } from "primeng/dialog";
import { Popover, PopoverModule } from "primeng/popover";
import { TagModule } from "primeng/tag";
import { CustomerInvoice } from "src/app/models/customer-invoice.model";
import { InvoiceType } from "src/app/models/enums/invoice-type.enum";

@Component({
    selector: "invoice-detail-component",
    templateUrl: "./invoice-detail.component.html",
    styleUrls: ["./invoice-detail.component.scss"],
    standalone: true,
    imports: [ButtonModule, CardModule, CommonModule, DialogModule, TagModule],
    providers: [],
})
export class InvoiceDetailComponent {
    @ViewChild('po') popover!: Popover;
    @Input() invoice!: CustomerInvoice;
    @Input() showInvoiceDetail: boolean = false;
    @Output() showInvoiceDetailChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    InvoiceType = InvoiceType;

    getInvoiceStatusClass(status: string): 'success' | 'secondary' | 'info' | 'warn' | 'danger' | 'contrast' | undefined {
        switch(status) {
            case 'Betaald':
                return 'success';
            case 'Open':
                return 'info';
            case 'Te laat':
                return 'danger';
            default:
                return undefined;
        }
    }

    getInvoiceStatus(invoice: CustomerInvoice): 'Betaald' | 'Open' | 'Te laat' {
        return invoice.outstandingAmount === 0 ? 'Betaald' :
            invoice.invoiceDate <= new Date() ? 'Open' : 'Te laat';
    }
}